/**
 * Project selection for the phone "Projects shown" sheet (Projects.dc.html).
 * The app's selection model is unchanged: an empty list (or a list holding
 * every project) means "All projects"; otherwise exactly the listed codes.
 */

/** True when the selection shows every project. */
export function allProjectsSelected(selectedCodes, projectCodes) {
  return selectedCodes.length === 0 || selectedCodes.length === projectCodes.length;
}

/** The codes the sheet draws as ticked. */
export function tickedCodes(selectedCodes, projectCodes) {
  return allProjectsSelected(selectedCodes, projectCodes) ? [...projectCodes] : [...selectedCodes];
}

/**
 * The selection after the user taps `code`'s checkbox. Unticking the last
 * ticked project, or ticking every project, returns [] (All projects).
 */
export function nextProjectSelection(selectedCodes, projectCodes, code) {
  const ticked = tickedCodes(selectedCodes, projectCodes);
  const next = ticked.includes(code) ? ticked.filter((c) => c !== code) : [...ticked, code];
  if (next.length === 0 || next.length === projectCodes.length) return [];
  return projectCodes.filter((c) => next.includes(c));
}

/** The pill text on the phone header: "All projects · SS418, EPHA" or "1 project · SS418". */
export function projectPillText(selectedCodes, projectCodes) {
  if (allProjectsSelected(selectedCodes, projectCodes)) return `All projects · ${projectCodes.join(", ")}`;
  return `${selectedCodes.length} project${selectedCodes.length === 1 ? "" : "s"} · ${selectedCodes.join(", ")}`;
}

/** The sheet's confirm button label: "Show all projects" or "Show 1 project". */
export function projectSheetButtonText(selectedCodes, projectCodes) {
  if (allProjectsSelected(selectedCodes, projectCodes)) return "Show all projects";
  return `Show ${selectedCodes.length} project${selectedCodes.length === 1 ? "" : "s"}`;
}
